export default {
    revenueBussiness : 1, // thu chi hđsn dv
    expenseBussiness : 2, // thu chi hđsn dv
    revenueFees : 3, // thu chi phí lệ phí
    expenseFees: 4,
    expenseInvest : 5, // chi đầu tư phát triển
    expenseRegular : 6, // chi thường xuyên
    expenseProject : 7, // chi ctmt
    calculationBasis : 8, // cơ sở tính
}
